import React, { useContext } from "react";
import moment from "moment";
import 'moment/locale/th'
import { Modal } from 'react-bootstrap';
import { AppContext } from "../context/ContextProvider";
import { useTranslation } from 'react-i18next'
import { transformFieldWithLang } from '../../utils/functions';

moment.locale('th')

// confirmLabel: ข้อความปุ่มยอมรับ -- ที่พัก gateway ใช้ "ยอมรับและไปชำระเงิน" เพราะกดแล้วไปหน้าจ่ายเงินทันที
const PolicyConfirmModal = ({ show, onHide = () => { }, hotel_id = {}, onAcceptTerm = () => { }, confirmLabel = null }) => {
  const { getCurrentHotel } = useContext(AppContext);
  const currentHotel = getCurrentHotel();

  const { t, i18n } = useTranslation()
  const lang = i18n.language || 'th'

  const termOfUse = transformFieldWithLang(currentHotel, 'terms_of_use', lang);

  return (
    <>
      <Modal size="lg" show={show} onHide={onHide} backdrop="static">
        <Modal.Header closeButton className="policy-confirm-header">
          <div className="policy-confirm-heading">
            <span className="policy-confirm-icon" aria-hidden="true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3L2 20h20L12 3z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                <path d="M12 10v4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <circle cx="12" cy="17.2" r="1.1" fill="currentColor" />
              </svg>
            </span>
            <div>
              <Modal.Title as="h5" className="policy-confirm-title">{t('please_review_privacy')}</Modal.Title>
              <div className="policy-confirm-subtitle">{t('please_review_privacy_hint')}</div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="booking-policy">
          {!!termOfUse && <div>
            <h4 className="policy-confirm-section">{transformFieldWithLang(currentHotel, 'terms_of_use_title', lang)}</h4>
            <div className="booking-term-condition" dangerouslySetInnerHTML={{ __html: termOfUse }} />
          </div>}
        </Modal.Body>
        <Modal.Footer>
          <div>
            <div className="tp-purchase-btn py-3 px-5 rounded" onClick={() => onAcceptTerm()}>
              {confirmLabel || t('confirm')} {" "}
              <span>
                <svg
                  width="22"
                  height="8"
                  viewBox="0 0 22 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="currentColor"
                  ></path>
                </svg>
                <svg
                  width="22"
                  height="8"
                  viewBox="0 0 22 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.3536 4.35356C21.5488 4.15829 21.5488 3.84171 21.3536 3.64645L18.1716 0.464468C17.9763 0.269205 17.6597 0.269205 17.4645 0.464468C17.2692 0.65973 17.2692 0.976312 17.4645 1.17157L20.2929 4L17.4645 6.82843C17.2692 7.02369 17.2692 7.34027 17.4645 7.53554C17.6597 7.7308 17.9763 7.7308 18.1716 7.53554L21.3536 4.35356ZM-4.37114e-08 4.5L21 4.5L21 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
            </div>
          </div>
          {/* <Button variant="secondary">ถัดไป</Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PolicyConfirmModal;
